<template>
    <div class="bodyBox">
        <div class="bodyLeft">
            <div class="BL-top">
                <div class="title">场馆介绍</div>
                <div class="contain lt-text" >
                    <div>山东博物馆，位于山东省济南市历下区经十路11899号，占地面积210亩，主体建筑面积82900平方米，展陈面积25000平方米，隶属山东省文化厅，是一所综合性博物馆。</div>
                    <div>
                        山东博物馆先后荣获由人力资源和社会保障部与国家文物局联合颁发的“全国文物系统先进集体”荣誉称号、获得全国爱国主义教育示范基地、全国科普教育基地、山东省爱国主义教育基地、山东省青少年教育基地、山东省关心下一代教育基地等称号。是济南陆军学院、山东交通学院、山东省实验中学、东方双语实验学校、燕山小学等一批大中小学的教学和德育基地，山东省妇女“双学双比”“巾帼建功”文明示范岗。 2012年，山东博物馆入选国家一级博物馆。
                    </div>
                </div>
            </div>
            <div class="BL-Box">
                <div class="title">基本信息</div>
                <div class="contain lc-box">
                    <div class="lc-Item">
                        <div class="imgTips tips-1"></div>
                        <div class="msgBg">楼栋</div>
                        <div class="msgBg">1幢</div>
                    </div>
                    <div  class="lc-Item">
                        <div class="imgTips tips-2"></div>
                        <div class="msgBg">展陈面积</div>
                        <div class="msgBg">25000m²</div>
                    </div>
                    <div  class="lc-Item">
                        <div class="imgTips tips-3"></div>
                        <div class="msgBg">建筑面积</div>
                        <div class="msgBg">82900m²</div>
                    </div>
                </div>
            </div>
            <div class="BL-Box">
                <div class="title">设备在线率</div>
                <div class="contain">
                    <lineChart :data="onlineRateList"/>
                </div>
            </div>
        </div>
        <div class="bodyCenter">
            <div class="bodyItem" v-for="(item, index) in siteLocationStateCount" :key="index">
                <div class="bodyTitle">{{ item.name }}</div>
                <div class="bodyValue">
                    <div class="ok">正常 {{ item.normal }}</div>
                    <div class="warning">超限 {{ item.abnormal }}</div>
                </div>
            </div>
        </div>
        <div class="bodyCenterBottom">
            <div class="BCB-title">
                <div class="time">位置</div>
                <div class="posi">文物(件/套)</div>
                <div class="fact">设备(个)</div>
            </div>
            <vue3-seamless-scroll :list="hallRelicLocationCount" class="seamless-warp" :step="0.5" :hover="true">
                <div class="LineBox" v-for="(item, index) in hallRelicLocationCount" :key="index">
                    <div class="time">{{ item.name }}</div>
                    <div class="posi">{{ item.hallRelicCount }}</div>
                    <div class="fact">{{ item.hallLocationCount }}</div>
                </div>
            </vue3-seamless-scroll>
        </div>
        <div class="bodyLeft bodyRight">
            <div class="BL-top">
                <div class="title">监测概览</div>
                <div class="contain BR-box">
                    <div class="sideBox">
                        <div>{{ cabinetCount }}个</div>
                        <div class="name">展柜</div>
                    </div>
                    <div class="centerBox">
                        <div class="sideBox">
                            <div>{{ hallCount }}个</div>
                            <div class="name">展厅</div>
                        </div>
                        <div class="sideBox">
                            <div>{{ locationCount }}个</div>
                            <div class="name">设备</div>
                        </div>
                    </div>
                    <div class="sideBox">
                        <div>{{ relicCount }}个</div>
                        <div class="name">文物</div>
                    </div>
                </div>
            </div>
            <div class="BL-Box">
                <div class="title">环境数据</div>
                <div class="contain BR-center">
                    <div class="BRC-item" v-for="(item, index) in listSeners" :key="index">
                        <img class="iconTips" :src="item.img"  v-if="item.flag"/>
                        <div class="msgTips" v-if="item.flag">
                            <div><span class="count" :style="`color:${item.color}`">{{ item.num }}</span>{{ item.unit }}</div>
                            <div class="name">{{ item.name }}</div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="BL-Box">
                <div class="title">预警统计</div>
                <div class="contain BR-bottom">
                   <div class="lineItem" v-for="(item, index) in warningList" :key="index">
                        <div class="lineMsg">
                            <div class="boxLine">
                                <img class="imgIcon" :src="item.img" />
                                <div class="fontCss">{{ item.name }}</div>
                            </div>
                            <div class="boxLine">
                                <div>{{item.percent}}%</div>
                                <div class="fontCss">{{item.num}}条</div>
                            </div>
                        </div>
                        <el-progress :show-text="false" :percentage="item.percent" :color="item.color" :stroke-width="10" />
                   </div> 
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import lineChart from '../../components/chart/lineChart.vue'
import { siteOverview } from '@/api/screen.js'
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
 export default{
    components:{
        lineChart,
        Vue3SeamlessScroll,
    },
    data(){
        return{
            siteId:'37010201',
            hallCount:0,//展厅数量
            cabinetCount:0,//展柜数量
            relicCount:0,//文物数量
            locationCount:0,//设备数量
            onlineRateList:[],
            siteLocationStateCount:[],//站点下设备状态数量
            listSeners:[
                {name:'温度', sensorPhysicalid:33, img:require('../../assets/img/s-wd.png'), num:26, unit:'℃',color:'#FD1410'},
                {name:'湿度', sensorPhysicalid:32, img:require('../../assets/img/s-sd.png'), num:36, unit:'%RH',color:'#7DB1F9'},
                {name:'光照', sensorPhysicalid:41, img:require('../../assets/img/s-gz.png'), num:6189.32, unit:'lx',color:'#FFD310'},
                {name:'紫外', sensorPhysicalid:42, img:require('../../assets/img/s-zw.png'), num:0, unit:'uw/cm²',color:'#A95CC8'},
                {name:'二氧化碳', sensorPhysicalid:36, img:require('../../assets/img/s-co2.png'), num:952, unit:'ppm',color:'#40F969'},
                {name:'VOC', sensorPhysicalid:1, img:require('../../assets/img/s-voc.png'), num:568, unit:'ppb',color:'#40F969'},
            ],
            warningList:[
                {name:'一级预警', img:require('../../assets/img/w-1.png'), num:0, color:'#F62D2D', percent:0},
                {name:'二级预警', img:require('../../assets/img/w-2.png'), num:0, color:'#E16601', percent:0},
                {name:'三级预警', img:require('../../assets/img/w-3.png'), num:0, color:'#F6C02D', percent:0},
                {name:'四级预警', img:require('../../assets/img/w-4.png'), num:0, color:'#2DF645', percent:0}
            ],
            hallRelicLocationCount:[],
        }
    },
    mounted(){
        this.SiteOverview()
    },
    methods:{
        SiteOverview(){
            siteOverview(this.siteId).then(r=>{
                let data = r.data
                this.hallCount = data.hallCount//展厅数量
                this.cabinetCount = data.cabinetCount//展柜数量
                this.relicCount = data.relicCount//文物数量
                this.locationCount = data.locationCount//设备数量
                this.onlineRateList = data.onlineRateList.map(i=>{ //设备在线率
                    return [i.date, i.count]
                }) 
                this.siteLocationStateCount = data.siteLocationStateCount
                let siteSensorDataList = data.siteSensorDataList
                this.listSeners = this.listSeners.map(i=>{
                    let senerData = siteSensorDataList.find(item=>{
                        return item.sensorPhysicalid == i.sensorPhysicalid
                    })
                    let obj = i
                    if(senerData){
                        obj['flag'] = true
                        obj['unit'] = senerData.units
                        obj['num'] = senerData.sensorPhysicalValue
                    }else{
                        obj['flag'] = false
                    }
                    return obj
                })
                this.hallRelicLocationCount = data.hallRelicLocationCount

                let alarmCount = r.data.alarmCount.filter(i=>{
                    return i.alarmGrade != 0
                })
                let sum = alarmCount.reduce((sumData,key,index,arrData)=>{
                    return sumData+key.count
                },0)
                alarmCount.forEach(el => {
                    switch (el.alarmGrade){
                        case 1:
                            this.warningList[0].num =  el.count
                            if(sum!=0){
                                this.warningList[0].percent =  ((el.count/sum)*100).toFixed(2)
                            }
                            
                            break;
                        case 2:
                            this.warningList[1].num =  el.count
                            if(sum!=0){
                                this.warningList[1].percent =  ((el.count/sum)*100).toFixed(2)
                            }
                            break;
                        case 3:
                            this.warningList[2].num =  el.count
                            if(sum!=0){
                                this.warningList[2].percent =  ((el.count/sum)*100).toFixed(2)
                            }
                            break;
                        case 4:
                            this.warningList[3].num =  el.count
                            if(sum!=0){
                                this.warningList[3].percent = ((el.count/sum)*100).toFixed(2)
                            }
                            break;
                        default: 0;
                    }
                    
                });
                
            })
        }
    }
 }
</script>
<style lang="scss" scoped>
 .bodyBox{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 50px;
    box-sizing: border-box;
    position: relative;
    .bodyCenter{
        width: 800px;
        position: absolute;
        top: 150px;
        left: calc(50% - 400px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        .bodyItem{
            height: 90px;
            pointer-events: all;
            background-image: url('../../assets/img/topbg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
            .bodyTitle{
                display: inline-block;
                color: white;
                padding: 2px 5px;
                background-image: linear-gradient(to right,#12204820,#35b9f2,#12204820);
            }
            .bodyValue{
                display: flex;
                width: 100%;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;
                .ok{
                    color: rgb(13, 196, 13);
                }
                .warning{
                    color: rgb(255, 45, 45);
                }
            }
        }
    }
    .bodyCenterBottom{
        width: 800px;
        height: 200px;
        pointer-events: all;
        position: absolute;
        bottom: 50px;
        left: calc(50% - 400px);
        .BCB-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;
            background-color:#16c0ba83;
            color: rgb(255, 255, 255);
            height: 30px;
            .time{
                width: 300px;  
            }
            .posi{
                width: 250px;
            }
            .fact{
                width: 250px;
            }
        }
        .LineBox{
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;
            height: 30px;
            border-bottom: 1px solid rgba(255, 250, 250, 0.3);
            box-sizing: border-box;
            .time{
                width: 300px;  
            }
            .posi{
                width: 250px;
            }
            .fact{
                width: 250px;
            }  
        }
        .seamless-warp {
            box-sizing: border-box;
            width: 100%;
            margin-top: 10px;
            height: calc(100% - 50px);
            font-size: 14px;
            color: #35DBFF;
            overflow: hidden;
        }
    }
    .bodyLeft{
        width: 500px;
        height: 100%;
        padding: 0px 65px 0px 30px;
        box-sizing: border-box;
        background-image: url('../../assets/img/left-insert.png');
        background-size:contain;
        background-position: 100% 50%;
        background-repeat: no-repeat;
        .BL-top{
            width: 100%;
            height: 30%; 
            .lt-text{
                line-height: 20px;
                font-size: 14px;
                text-align: justify;
                display: flex;
                justify-content: center;
                align-items: center;
                text-indent: 2rem;
                flex-direction: column;
                color: white;
            }
        }
        .BL-Box{
            width: 100%;
            margin-top: 10px;
            height: calc(35% - 15px); 
            pointer-events: all;
        }
        .lc-box{
            display: flex;
            justify-content: space-around;
            align-items: center;
            .lc-Item{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-direction: column;
            }
            .imgTips{
               width: 45px;
               height: 45px;
               margin-bottom: 30px;
            }
            .tips-1{
               background-image: url('../../assets/img/ld.png');
               background-size: contain;
               background-position: 50% 50%; 
            }
            .tips-2{
               background-image: url('../../assets/img/area.png');
               background-size: contain;
               background-position: 50% 50%; 
            }
            .tips-3{
               background-image: url('../../assets/img/build.png');
               background-size: contain;
               background-position: 50% 50%; 
            }
            .msgBg{
                margin-top: 10px;
                padding: 5px 20px;
                background-image: url('../../assets/img/textBg.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                color: white;
                font-size: 16px;
            }
        }
    }
    .bodyRight{
        padding: 0px 30px 0px 65px;
        background-image: url('../../assets/img/right-insert.png');
        background-size:contain;
        background-position: 0% 50%;
        background-repeat: no-repeat;
        .BR-box{
            background-image: url('../../assets/img/bottomBg.png');
            background-size:contain;
            background-position:50% 100%;
            background-repeat: no-repeat;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .sideBox{
                width: 80px;
                height: 50%;
                background-image: url('../../assets/img/itemBg.png');
                background-size:contain;
                background-position:50% 50%;
                background-repeat: no-repeat;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                font-size: 16px;
                color: white;
                .name{
                    margin-top: 20px;
                    font-size: 14px;
                }
            }
            .centerBox{
                height: 100%;
            }
        }
        .BR-center{
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            padding: 0px 0px 0px 40px;
            box-sizing: border-box;
            .BRC-item{
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 50%;
                .iconTips{
                    width: 40px;
                    height: 50px;
                    object-fit: contain;
                }
                .msgTips{
                    font-size: 14px;
                    color: #D0DFE3;
                    width: calc(100% - 50px);
                    .count{
                        font-size: 20px;
                        font-weight: bold;
                    }
                }
            }
        }
        .BR-bottom{
            width: 100%;
            padding: 10px 10px 20px 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
            .lineItem{
                width: 100%;
                .lineMsg{
                    margin-bottom: 5px;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .boxLine{
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        color: white;
                        .imgIcon{
                            width: 20px;
                            height: 20px;
                            object-fit: contain;
                        }
                        .fontCss{
                            margin-left: 20px;

                        }
                    }
                }
            }
           
        }
    }

    .title{
        width: 100%;
        height: 32px;
        line-height: 26px;
        padding: 0px 26px;
        font-weight: 600;
        font-size: 18px;
        color: #1BFFF6;
        box-sizing: border-box;
        background-image: url('../../assets/img/title.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    .contain{
        width: 100%;
        height: calc(100% - 32px);
    }
}
:deep(.el-progress-bar__outer){
    background-color: #76b8b67d;
}
</style>